import Repository from './Repository'

const resource = '/phone'

export default {
  async getListCallInformation (phone, direction, phoneCalled, conferenceSid, isSilent = false) {
    try {
      return await Repository.get(`${resource}/${phone}/call-information/${direction}`, { phoneCalled: phoneCalled, conferenceSid: conferenceSid }, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getListCallHistory (params, isSilent = true) {
    try {
      return await Repository.post(`${resource}/call-history`, params, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async saveCallHistory (params, isSilent = false) {
    try {
      return await Repository.post(`${resource}/save/call-history`, params, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async saveCallHistoryNoteCTI (params) {
    try {
      return await Repository.post(`${resource}/call-history/note`, params, {}, {}, true)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async saveCallBack (params) {
    try {
      return await Repository.post(`${resource}/add-history-call-back`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async removeCallback(callSid) {
    try {
      return await Repository.delete(`${resource}/remove-history-call-back/${callSid}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getConference (callSid) {
    try {
      return await Repository.get(`${resource}/${callSid}/conference`, {}, {}, true)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async holdConference (params) {
    try {
      return await Repository.post(`${resource}/hold`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getAvailableWorkers (params) {
    try {
      return await Repository.post(`${resource}/available-workers`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async transferCall (params) {
    try {
      const callSid = params.callSid
      return await Repository.post(`${resource}/create-transfer/${callSid}`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async joinConference (params) {
    try {
      const callSid = params.conference.conferenceSid
      return await Repository.post(`${resource}/join-conference/${callSid}`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getCurrentCalls () {
    try {
      return await Repository.get(`${resource}/worker-status`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getWorkerStatus () {
    try {
      return await Repository.get(`${resource}/worker-status`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async acceptIncomingCall (params) {
    try {
      return await Repository.post(`${resource}/accept`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getCTIContact (tel) {
    try {
      return await Repository.getCTI(`${resource}/cti/${tel}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
